/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_Mark_AllInputs */

const en_portalnotify_mark_all = /** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark all read`)
};

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const ar_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const he_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const ur_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const es_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const fr_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const de_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const pt_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const hi_portalnotify_mark_all = en_portalnotify_mark_all;

/** @type {(inputs: Portalnotify_Mark_AllInputs) => LocalizedString} */
const bn_portalnotify_mark_all = en_portalnotify_mark_all;

/**
* | output |
* | --- |
* | "Mark all read" |
*
* @param {Portalnotify_Mark_AllInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_mark_all = /** @type {((inputs?: Portalnotify_Mark_AllInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_Mark_AllInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_mark_all(inputs)
	if (locale === "he") return he_portalnotify_mark_all(inputs)
	if (locale === "ur") return ur_portalnotify_mark_all(inputs)
	if (locale === "es") return es_portalnotify_mark_all(inputs)
	if (locale === "fr") return fr_portalnotify_mark_all(inputs)
	if (locale === "de") return de_portalnotify_mark_all(inputs)
	if (locale === "pt") return pt_portalnotify_mark_all(inputs)
	if (locale === "hi") return hi_portalnotify_mark_all(inputs)
	if (locale === "bn") return bn_portalnotify_mark_all(inputs)
	return /** @type {LocalizedString} */ ("Mark all read")
});